import { defineStore } from 'pinia';
import { IntercomContext } from 'types/intercom';
import { ref } from 'vue';
import { useAppStore } from '@stores/app';

export const userIntercomStore = defineStore('intercom', () => {
	const enabled = ref<boolean | null>(null);
	const context = ref<IntercomContext | null>(null);

	async function storeFeatureEnabled(): Promise<void> {
		const appStore = useAppStore();
		enabled.value = await appStore.isFeatureEnabled('intercom-chat-bot');
	}

	return {
		enabled,
		context,
		storeFeatureEnabled
	};
});
